"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIssuingSupported = void 0;
const country_1 = require("../enums/country");
const isIssuingSupported = (country) => {
    return country === country_1.OrganizationCountry.UnitedStates;
};
exports.isIssuingSupported = isIssuingSupported;
